import React from 'react';

// Stage Wrapper Components (Each handles its own subStages internally)
import Kyc from '../components/application/consumer/kyc/index';
import Product from '../components/application/consumer/product/product';
import BankDetails from '../components/application/consumer/bank/BankDetails';
import DocumentUpload from '../components/application/consumer/documents/documentUpload';
import SerialNumberValidation from '../components/application/consumer/serial-number-validation/serialNumberValidation';
import InvoiceDetails from '../components/application/consumer/invoice-details/invoiceDetails';
import EligiblityCheck from '../components/application/eligibility/EligiblityCheck';
import EligiblitySteps from '../components/application/eligibility';

export const STAGE_COMPONENT_MAP = {
  // Each stage returns its wrapper component
  credit_decision: EligiblitySteps,
  kyc: Kyc,
  product: Product,
  mandate: BankDetails,
  document: DocumentUpload,
  imei_validation: SerialNumberValidation,
  invoice_details: InvoiceDetails
};

// Stage progression configuration
export const STAGE_STEPS = [
  { key: 'credit_decision', name: 'Basic Details', step: 1 },
  { key: 'kyc', name: 'KYC', step: 2 },
  { key: 'product', name: 'Product Details', step: 3 },
  { key: 'mandate', name: 'Bank Details', step: 4 },
  { key: 'document', name: 'Documents', step: 5 },
  { key: 'imei_validation', name: 'IMEI Validation', step: 6 },
  { key: 'invoice_details', name: 'Invoice Details', step: 7 }
];

export const TOTAL_STEPS = STAGE_STEPS.length;

export const getCurrentStepInfo = (stage, subStage) => {
  const currentStage = STAGE_STEPS.find(s => s.key === stage);
  
  if (!currentStage) {
    return { currentStep: 1, totalSteps: TOTAL_STEPS };
  }

  return {
    currentStep: currentStage.step,
    totalSteps: TOTAL_STEPS,
    stageName: currentStage.name
  };
};

export const getProgressPercentage = (stage, subStage) => {
  const { currentStep, totalSteps } = getCurrentStepInfo(stage, subStage);
  const percentage = Math.round((currentStep / totalSteps) * 100);
  return percentage;
};


export const getComponentForStage = (stage, subStage) => {
  if (!stage) {
    return null;
  }

  // Simply return the stage wrapper component
  // Each wrapper will handle subStage internally
  return STAGE_COMPONENT_MAP[stage] || STAGE_COMPONENT_MAP[stage.toLowerCase()] || null;
};

export const renderStageComponent = (stage, subStage) => {
  const Component = getComponentForStage(stage, subStage);
  
  if (!Component) {
    return (
      <div className="col-12 d-flex justify-content-center align-items-center" style={{minHeight: '300px'}}>
        <div className="text-center">
          <div className="alert alert-warning">
            <h5>Stage Not Available</h5>
            <p>The requested application stage ({stage}/{subStage}) is not configured.</p>
          </div>
        </div>
      </div>
    );
  }
  
  return <Component />;
};